export default __webpack_public_path__ + "static/media/0010.c835cd31.png";